module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade modalConnection"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("connection.modal.title")))])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('connection', {
    attrs: {
      "classes": _vm.classes
    }
  }), _c('div', {
    staticClass: "clearFix"
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e72d09b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Connection/ConnectionModal.vue
// module id = 1277
// module chunks = 1